import { render, staticRenderFns } from "./newAllMain.vue?vue&type=template&id=67fd299e&scoped=true"
import script from "./newAllMain.vue?vue&type=script&lang=js"
export * from "./newAllMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd299e",
  null
  
)

export default component.exports